import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./car.css";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import {createBrowserHistory} from 'history';
import {CookiesProvider} from "react-cookie";
import MultiStepFormCAR from "./components/MultiStepFormCAR";
import HeaderTFAF from "./components/HeaderTFAF";
import FooterTFAF from "./components/FooterTFAF";
import PaymentSuccess from "./components/PaymentSuccess";
import SessionExpired from "./components/SessionExpired";
import Converted from "./components/Converted";
import Expired from "./components/Expired";
import PageNotFound from "./components/PageNotFound";
import CreditCardPaymentSuccess from "./components/CreditCardPaymentSuccess";
import CreditCardPaymentFailure from "./components/CreditCardPaymentFailure";
import CreditCardPaymentCancel from "./components/CreditCardPaymentCancel";
import ErrorPage from "./components/ErrorPage";
import AgeOfVehicleErrorPage from "./components/AgeOfVehicleErrorPage";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";

export const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL
});

ReactDOM.render(<CookiesProvider>
    <GoogleReCaptchaProvider reCaptchaKey="6LeyJ7IqAAAAAKoJo1rsg6cNch-Db3TDm3TKryo7">
    <Router history={history}>
        <HeaderTFAF/>
        <Routes>
            <Route path="/vehicle" element={<MultiStepFormCAR/>}/>
            <Route path="/paymentsuccess" element={<PaymentSuccess/>}/>
          <Route path="/vehicle/session-expired" element={<SessionExpired/>}/>
          <Route path="/vehicle/converted" element={<Converted/>}/>
          <Route path="/vehicle/expired" element={<Expired/>}/>
            <Route path="/page-not-found" element={<PageNotFound/>}/>
            <Route path="/cc-payment-success" element={<CreditCardPaymentSuccess/>}/>
            <Route path="/cc-payment-failure" element={<CreditCardPaymentFailure/>}/>
            <Route path="/cc-payment-cancel" element={<CreditCardPaymentCancel/>}/>
            <Route path="/error-occurred" element={<ErrorPage/>}/>
            <Route path="/age-of-vehicle-error" element={<AgeOfVehicleErrorPage/>}/>
        </Routes>
        <FooterTFAF/>
    </Router>
    </GoogleReCaptchaProvider>
</CookiesProvider>, document.getElementById("root"));

